import React from 'react'
import SingleCourseAddOn from './singleCourseAddOn'

/**
 * Course add on the course details section, not the course add ons that appear in the current course table
 * @param {Object} courseAddOns - All the course add ons for a course instance
 * @returns 
 */
function CourseAddOns({courseAddOns}) {

    // Component level JSX return statement ******************************************************
    return (
        <section id="add-ons" className="pattern-block">
                <div className="container">
                    <h2 className="pattern-block__headline border-headline">Add-on Course Packages</h2>
                    
                    <div className="flex-row">
                        {courseAddOns.map((courseAddOn) => {
                            return(
                                <SingleCourseAddOn courseAddOn={courseAddOn} />
                            )
                        })}
                    </div>
                    
                </div>
            </section>
    )
}
export default CourseAddOns;